import { CommonLocalizationKeys } from './interface';

const common: CommonLocalizationKeys = {
	Common_currency: '{{val, currency(currency: PLN; minimumFractionDigits: 2; maximumFractionDigits: 2)}}',
	Common_freebet_currency: '{{val, currency(currency: PLN; minimumFractionDigits: 0; maximumFractionDigits: 2)}}',
	Common_relativeTime: '{{val, relativetime(day)}}',
	Common_dateTime: '{{val, datetime(dateStyle: long; timeStyle: medium)}}',
	Common_date: '{{val, datetime(dateStyle: long)}}',
	Common_decimal: '{{val, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}}',
	Common_dateTimeShort: '{{val, datetime(dateStyle: short; timeStyle: short)}}',
};

export default common;
